const ERROR_MESSAGES = {
  OTP_NOT_FOUND: '验证码不存在',
  INVALID_OTP: '验证码错误',
  OTP_EXPIRED: '验证码已过期，请重新获取',
};

export const resolveLoginErrorMessage = (error, fallback = '登录失败，请重试') => {
  if (!error) {
    return fallback;
  }
  return ERROR_MESSAGES[error.code] || error.message || fallback;
};

export const getSafeRedirectUrl = (redirect) => {
  if (!redirect?.startsWith('/')) {
    return undefined;
  }
  if (redirect.startsWith('//')) {
    return undefined;
  }
  try {
    const parsed = new URL(redirect, window.location.origin);
    if (parsed.origin !== window.location.origin) {
      return undefined;
    }
    return `${parsed.pathname}${parsed.search}${parsed.hash}`;
  } catch {
    return undefined;
  }
};

export const getDefaultOrganizationPath = (organizations) => {
  const organizationList = Array.isArray(organizations) ? organizations : [];
  if (organizationList.length === 0) {
    return '/welcome';
  }
  return `/${encodeURIComponent(organizationList[0].id)}`;
};

export const resolveLoginPostPath = ({ redirect, from, organizations, user }) => {
  const safeRedirect = getSafeRedirectUrl(redirect);
  if (safeRedirect) {
    return safeRedirect;
  }
  if (from) {
    return from;
  }
  if (user?.isPlatformAdmin) {
    return '/admin';
  }
  return getDefaultOrganizationPath(organizations);
};

export const getOrgRedirectPlan = ({ pathname, organizationId, organizations, from }) => {
  const organizationList = Array.isArray(organizations) ? organizations : [];
  const isLoginPage = pathname === '/';
  const isWelcomePage = pathname === '/welcome';
  const hasOrganizations = organizationList.length > 0;
  const defaultOrganizationPath = getDefaultOrganizationPath(organizationList);

  if (isLoginPage) {
    return { to: from || defaultOrganizationPath };
  }

  if (isWelcomePage) {
    return hasOrganizations ? { to: defaultOrganizationPath } : null;
  }

  if (!hasOrganizations) {
    return { to: '/welcome', message: { type: 'warning', text: '未发现可用组织' } };
  }

  if (!organizationId) {
    return { to: defaultOrganizationPath };
  }

  const isValidOrg = organizationList.some((org) => org.id === organizationId);
  if (!isValidOrg) {
    return {
      to: defaultOrganizationPath,
      message: { type: 'error', text: '您没有权限访问该组织' },
    };
  }

  return null;
};
